import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import includes from 'lodash/includes';

import './InteractiveMapMarker.scss';

const MARKER_SVG_PATH =
    'M12.1230385,-1 C19.3706925,-1 25.2460769,4.87538444 25.2459656,12.1379605 L25.2401352,12.5211513 C25.1417542,15.8138369 23.8238074,18.9122297 21.5647242,21.2360825 L12.1362691,31.7952232 L11.3902364,30.962093 L2.71888509,21.2780022 L2.45764552,20.9990107 C0.221261174,18.5423325 -1,15.4205261 -1,12.1230385 C-1,4.87538444 4.87538444,-1 12.1230385,-1 Z';

export default class InteractiveMapMarker extends React.PureComponent {
    static propTypes = {
        onMapMarkerClick: PropTypes.func,
        eventsId: PropTypes.arrayOf(PropTypes.string),
        isMobileViewEventDefaultSelected: PropTypes.bool,
        mobileViewHoverTarget: PropTypes.string,
    };

    static defaultProps = {
        eventsId: [],
        onMapMarkerClick: noop,
    };

    _setRef = (node) => {
        this._ref = node;
    };

    _handleMapMarkerClickWithPosition = () => {
        this.props.onMapMarkerClick(this._ref);
    };

    render() {
        const {
            eventsId,
            hoverEventCardTarget,
            mobileViewHoverTarget,
        } = this.props;

        const shouldHover = !!eventsId.find((eventId) =>
            includes([hoverEventCardTarget, mobileViewHoverTarget], eventId),
        );
        const containerClassName = classNames(
            'interactive-map-marker__container',
            {
                'interactive-map-marker__container--hover': shouldHover,
            },
        );

        let textComponent = null;

        return (
            <div
                className={containerClassName}
                data-spec="interactive-map-marker-container"
            >
                <svg
                    className="interactive-map-marker"
                    ref={this._setRef}
                    xmlns="http://www.w3.org/2000/svg"
                    width="29"
                    height="35"
                    onClick={this._handleMapMarkerClickWithPosition}
                    onKeyDown={this._handleMapMarkerClickWithPosition}
                    role="button"
                >
                    <path
                        fillRule="evenodd"
                        d={MARKER_SVG_PATH}
                        stroke="#2D2E3B"
                        strokeWidth="2px"
                        transform="translate(2 2)"
                    />
                    {textComponent}
                </svg>
            </div>
        );
    }
}
